import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import "./publication.css";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { InfinitySpin } from "react-loader-spinner";

function Publication() {
  const [value, setValue] = React.useState(0);
  const [pubBody, setPubBody] = useState([]);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const urlArr = location.pathname.split("/");
  const url = urlArr[urlArr.length - 1];
  console.log(url);
  let urlRegex = /(https?:\/\/[^\s]+)/g;

  const handleChange = (event, newValue) => {
    console.log("val ", newValue);
    setValue(newValue);
  };

  useEffect(() => {
    window.scrollTo(0, 200);
    async function netlifyFunc() {
      const res = await fetch(
        "https://dratunroychoudhury.netlify.app/.netlify/functions/publication-function",
        {
          method: "post",
          headers: { "Content-Type": "Application/json" },
          body: JSON.stringify({ url: url }),
        }
      );
      const data = await res.json();
      data.sort((a, b) => a.Year - b.Year);
      console.log("data ", data);
      setPubBody(data);
      setLoading(false);
    }
    netlifyFunc();
  }, [url]);

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        {loading ? (
          <InfinitySpin
            visible={true}
            height="196"
            width="196"
            color="green"
            strokeWidth="5"
            animationDuration="0.75"
            ariaLabel="rotating-lines-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        ) : (
          <Box>
            <table>
              <tr>
                {Object.keys(pubBody[0]).map((heading) => (
                  <th>{heading}</th>
                ))}
              </tr>
              {pubBody.map((row) => (
                <tr>
                  {Object.keys(row).map((col) => {
                    return String(row[col]).match(urlRegex) !== null ? (
                      <td>
                        <Link to={row[col]} className="link" target="_blank">
                          link
                        </Link>
                      </td>
                    ) : (
                      <td>{row[col]}</td>
                    );
                  })}
                </tr>
              ))}
            </table>
          </Box>
        )}
      </Box>
    </>
  );
}

export default Publication;
